<template>
    <div class="app-container">
        <el-row class="main-flex">

            <!-- 搜索区域 -->
            <el-col :span="24" class="mian-content">

                <div class="head-section">
                    <el-col :span="6">
                        <el-form :inline="true">
                            <el-form-item label="模型名称：">
                                <el-input v-model.trim="query.name" placeholder="请输入模型名称"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <el-col :span="6">
                        <el-form :inline="true">
                            <el-form-item label="模型类型：">
                                <el-select v-model="query.type" placeholder="请选择模型类型" clearable>
                                    <el-option clearable v-for="item in typeList" :key="item.value" :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <el-col :span="6">
                        <el-form :inline="true">
                            <el-form-item label="开始时间：" >
                                <el-time-picker
                                    format="HH:mm:ss"
                                    value-format="HH:mm:ss"
                                    v-model="query.startTime"
                                    :picker-options="{ selectableRange: '00:00:00 - 23:59:59'}"
                                    placeholder="请选择开始时间">
                                </el-time-picker>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <el-col :span="6">
                        <div class="btn-end">
                            <span class="more-search" @click="showMore=!showMore">
                                <div>展开</div>
                            <i :class="showMore==true?'el-icon-arrow-down':'el-icon-arrow-up'"></i> </span>
                            <span class="btn-rest">
                            <el-button @click="resFuntion()" plain>重置</el-button>
                            </span>
                            <span class="btn-submit">
                            <el-button @click="getAllPage()" type="primary" plain>查询
                            </el-button>
                            </span>
                        </div>
                    </el-col>
                </div>
                <transition name="el-zoom-in-top">
                    <div v-show="showMore">
                        <div class="head-section head-section2">

                            <el-col :span="6">
                                <el-form :inline="true">
                                    <el-form-item label="结束时间：" >
                                        <el-time-picker
                                            format="HH:mm:ss"
                                            value-format="HH:mm:ss"
                                            v-model="query.endTime"
                                            :picker-options="{ selectableRange: '00:00:00 - 23:59:59'}"
                                            placeholder="请选择结束时间">
                                        </el-time-picker>
                                    </el-form-item>
                                </el-form>
                            </el-col>
                        </div>
                    </div>
                </transition>

                <!--  表格部分-->
                <div class="section-main">
                    <el-col class="choose-mian">
                        <div class="section-title">
                            {{dateName}}列表
                        </div>
                        <div>
                            <!--选择项栏-->
                            <span class="alert-box">
                          已选择{{ batchNum.length }}项
                            <span @click="cleanList" style="margin-left:8px;color:#0D6CE4;cursor:pointer;">清空</span>
                        </span>

                            <span class="pain-btn">
                                <el-button @click="handleClose" plain>退出
                            </el-button>
                            </span>

                            <span class="pain-btn">
                                <el-button @click="removeAll"
                                           v-hasCode="['elec:time:delete']" plain>删除
                            </el-button>
                            </span>
                            <span class="add-btn">
                                <el-button @click="addModel" type="primary"
                                           v-hasCode="['elec:time:add']" plain> 新增
                            </el-button>
                            </span>
                        </div>

                    </el-col>
                    <el-col :span="24">
                        <el-row class="table-box">
                            <el-table ref="equipTable" id="equipment" @selection-change="batchList"
                                      :data="tableData" height="100%"
                                      :header-cell-style="headerStyleEvent" :cell-class-name="goodsInfo">
                                <el-table-column align="center" type="selection"></el-table-column>
                                <el-table-column align="center" label="编号" type="index" :index="renIndex"></el-table-column>

                                <el-table-column align="center" label="模型名称" prop="name" min-width="150"
                                                 :show-overflow-tooltip="true"></el-table-column>

                                <el-table-column align="center" prop="type" label="类型" min-width="100px">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type  === 1"> 尖时刻 </span>
                                        <span v-else-if="scope.row.type === 2">峰时刻</span>
                                        <span v-else-if="scope.row.type === 3">平时刻</span>
                                        <span v-else-if="scope.row.type === 4">谷时刻</span>
                                    <span v-else>未知</span>
                                    </template>
                                </el-table-column>

                                <el-table-column align="center" prop="startTime" label="开始时间"
                                                 min-width="120"></el-table-column>

                                <el-table-column align="center" prop="endTime" label="结束时间"
                                                 min-width="120"></el-table-column>

                                <el-table-column align="center" label="操作" width="100" fixed="right">
                                    <template slot-scope="scope">
                                            <span class="edit-style" @click="compileEqu(scope.row)" v-hasCode="['elec:time:update']">
                                                编辑
                                            </span>

                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-col>
                    <el-col :span="24">
                        <el-row class="pagin">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="query.pageNum"
                                :page-sizes="[20, 30, 50,100]"
                                :page-size="query.pageSize"
                                layout="total, sizes, prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </el-row>
                    </el-col>
                </div>

            </el-col>

        </el-row>
        <el-dialog
            :title="isequipemt?'新增时段模型':'修改时段模型'"
            :visible.sync="addOrUpdate"
            width="30%"
            @close="close">

            <el-form size="middle" ref="equipform" :rules="equipmentRules" :model="informationForm" label-width="160px">
                <el-row>
                    <el-col >
                        <el-form-item label="模型名称:" prop="name" class="form-name">
                            <el-input v-model="informationForm.name" maxlength="30" show-word-limit clearable></el-input>
                        </el-form-item>

                        <el-form-item label="类型" prop="type">
                            <el-select v-model="informationForm.type" placeholder="选择类型">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="开始时间" prop="startTime">
                            <el-time-picker
                                format="HH:mm:ss"
                                value-format="HH:mm:ss"
                                v-model="informationForm.startTime"
                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59'}"
                                placeholder="选择开始时间">
                            </el-time-picker>
                        </el-form-item>

                        <el-form-item label="结束时间" prop="endTime">
                            <el-time-picker
                                format="HH:mm:ss"
                                value-format="HH:mm:ss"
                                v-model="informationForm.endTime"
                                :picker-options="{  selectableRange: `00:00:00 - 23:59:59`}"
                                placeholder="选择结束时间">
                            </el-time-picker>
                        </el-form-item>

                    </el-col>
                </el-row>
            </el-form>

            <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="newequipemt">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import '@/assets/font/font.css';
import {
    selectElecTimePage, addElecTime, updateElecTime, elecTimeBatchDelete
} from '@/utils/operation'
export default {
    name: 'elecTime',
    components: {},
    data() {
        return {
            dateId: null, //分时(月日)模型id
            dateName:"",//分时(月日)模型名称

            priceId: null,//国网电价模型id
            priceName:"",//国网电价名称

            showMore: false,
            query: {
                name: null,
                type:null,
                startTime: null,
                endTime: null,
                pageNum: 1,
                pageSize: 20
            },
            total: 0,
            addOrUpdate: false,
            isAdd: true,
            isequipemt: true,
            batchNum: [],
            tableData: [],

            informationForm: {
                dateId: null,
                name: "",
                type: null,
                startTime: null,
                endTime: null
            },
            equipmentRules: {
                name: [
                    {required: true, message: '请输入模型名称', trigger: 'blur'}
                ],
                type: [
                    {required: true, message: '请选择类型', trigger: 'blur'}
                ],
                startTime: [
                    {required: true, message: '请选择开始时间', trigger: 'blur'}
                ],
                endTime: [
                    {required: true, message: '请选择结束时间', trigger: 'blur'}
                ]
            },
            typeList:[{label:"尖时刻",value:1},{label:"峰时刻",value:2},{label:"平时刻",value:3},{label:"谷时刻",value:4}]
        }
    },

    computed: {

    },

    created() {
        this.clientHeight = document.body.clientHeight - 240;
        //this.parms = this.$route.params && this.$route.params.billingModelId;
        this.dateId = this.$route.query.id;
        this.dateName = this.$route.query.name;

        this.priceId = this.$route.query.priceId;
        this.priceName = this.$route.query.priceName;
        this.getAllPage();
    },
    methods: {
        headerStyleEvent({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 1) {
                return 'padding:0px;'
            }
        },
        goodsInfo(row){
            if (row.columnIndex == 1) {
                return 'goodsInfo'
            }
        },

        forceUpdate() {
            this.$forceUpdate();
        },

        renIndex(index) {
            return (this.query.pageNum - 1) * this.query.pageSize + index + 1
        },

        //条件分页查询
        async getAllPage() {
            let data = this.query;
            data.dateId = this.dateId;//页面传递的模型id
            data.page = this.query.pageNum;
            data.size = this.query.pageSize;
            if(this.query.type){
                data.type = this.query.type;
            }
            if(this.query.name){
                data.name = this.query.name;
            }
            if(this.query.startTime){
                data.startTime = this.query.startTime;
            }
            if(this.query.endTime){
                data.endTime = this.query.endTime;
            }
            const result = await selectElecTimePage(data);
            if (result.data.code !== 200) return this.$msg.error('获取分时模型信息失败!');
            this.tableData = result.data.data.list;
            this.total = result.data.data.total;
        },

        getSearch() {
            this.query.pageNum = 1;
            this.getAllPage()
        },


        //重置
        resFuntion() {
            this.isAdd = true;
            this.query = {
                name: null,
                type:null,
                startTime: null,
                endTime: null,
                pageNum: 1,
                pageSize: 20
            };
            this.getAllPage();
        },


        batchList(list) {
            this.batchNum = list
        },
        close() {
            this.isequipemt = true
            this.resetForm();
            this.addOrUpdate = false
            this.$refs['equipform'].resetFields();
        },
        //新增与修改
        newequipemt() {
            this.$refs.equipform.validate(async valid => {
                if (!valid) return this.$msg.info('信息不能为空!')
                const data = JSON.parse(JSON.stringify(this.informationForm));
                data.dateId = this.dateId;
                try {
                    if (this.isequipemt) {
                        const res = await addElecTime(data)
                        if (res.data.code !== 200) return this.$msg.error('新增信息失败!' + res.data.msg);
                        this.$msg.success('新增信息成功!')
                        this.addOrUpdate = false
                        this.getAllPage()
                    } else {
                        const res = await updateElecTime(data)
                        if (res.data.code  !== 200) return this.$msg.error('修改信息失败!' + res.data.msg);
                        this.$msg.success('修改信息成功!')
                        this.addOrUpdate = false
                        this.getAllPage()
                    }
                } catch (error) {
                }
            })
        },

        //修改信息填充
        async compileEqu(row) {
            this.informationForm = row;
            this.isAdd = true;
            this.addOrUpdate = true;
            this.isequipemt = false;
        },

        handleSizeChange(val) {
            this.query.pageSize = val
            this.getAllPage()
        },
        handleCurrentChange(val) {
            this.query.pageNum = val;
            this.getAllPage();
        },
        cleanList() {
            this.$refs.equipTable.clearSelection()
        },

        addModel() {
            this.addOrUpdate = true;
            this.resetForm();
        },

        resetForm(){
            this.informationForm = {
                dateId: null,
                name: "",
                type: null,
                startTime: null,
                endTime: null
            }
        },

        handleClose() {
            console.log("======this.priceId=======",this.priceId)
            console.log("======this.priceName=======",this.priceName)
            this.$router.push({
                path: '/elecDate',
                query:{
                    id:this.priceId,//回传电网电价模型的id
                    name:this.priceName//回传电网电价模型的名称
                }
            })
        },

        //批量删除
        async removeAll() {
            if (this.batchNum.length === 0) return this.$msg.info('请选择需要删除的项')
            const config = await this.$MessageBox.confirm(
                "此操作将永久删除选中项, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).catch(e => e);
            if (config !== "confirm") return;
            try {
                const list = this.batchNum.map(item => {
                    return item.id
                })
                const res = await elecTimeBatchDelete(list)
                if (res.status !== 200) return this.$msg.error('删除失败')
                this.tableData = this.tableData.filter((item, i) => {
                    return item.id !== list[i]
                })
                this.$refs.equipTable.clearSelection()
                if (this.query.pageNum > 1 && this.tableData.length === 0) {
                    this.query.pageNum = this.query.pageNum - 1
                }
                this.$msg.success('删除成功')
                this.getAllPage()
            } catch (e) {
                console.log(e);
            }
        },
    },


    watch: {},


}
</script>

<style lang="less" scoped>
.app-container {
    background: rgba(255, 255, 255, 0);
    padding-left: 0px;
}

::v-deep .el-dialog__header {
    //background-color: #e4ebf1;

    .el-dialog__title {
        font-weight: bolder;

        .dialogCenter1 .block_5 {
            background-color: #e4ebf1;
            display: flex;
            flex-direction: row;
            margin: 10px 0;
            flex-wrap: wrap;

            [class^="block_5_box"] {
                text-align: left;
                box-sizing: border-box;
                padding: 10px 10px;
                display: flex;
                width: 25%;
                flex-direction: column;

                .contentbox {
                    font-weight: bold;
                }
            }
        }
    }
}

.block_5 {
    background-color: #e4ebf1;
    display: flex;
    flex-direction: row;
    margin: 20px 0;
    padding: 20px 20px;
    flex-wrap: wrap;

    [class^="block_5_box"] {
        text-align: center;

        box-sizing: border-box;
        padding: 15px 15px;
        padding-left: 30px;
        display: flex;
        width: 30%;
        // flex-direction: column;
        .contentbox {
            font-weight: bold;
            padding-left: 8px;
        }
    }
}

.block_2 {
    background-color: #e4ebf1;
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    flex-wrap: wrap;

    [class^="block_2_box"] {
        text-align: left;
        box-sizing: border-box;
        padding: 10px 10px;
        display: flex;
        width: 20%;
        flex-direction: column;

        .contentbox {
            font-weight: bold;
        }
    }
}

.block_3 {
    background-color: #e4ebf1;
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    flex-wrap: wrap;

    [class^="block_3_box"] {
        text-align: left;
        box-sizing: border-box;
        padding: 10px 10px;
        display: flex;
        width: 20%;
        flex-direction: column;

        .contentbox {
            font-weight: bold;
        }
    }
}

.block_4 {
    background-color: #e4ebf1;
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    flex-wrap: wrap;

    [class^="block_4_box"] {
        text-align: left;
        box-sizing: border-box;
        padding: 10px 10px;
        display: flex;
        width: 20%;
        flex-direction: column;

        .contentbox {
            font-weight: bold;
        }
    }
}

.box1_1 {
    text-align: left;
    box-sizing: border-box;
    padding: 10px 10px 10px 0px;
    display: flex;
    width: 50%;
    flex-direction: column;
}

.box1_2 {
    text-align: left;
    box-sizing: border-box;
    padding: 10px 10px;
    display: flex;
    width: 50%;
    flex-direction: column;
}

.circular {
    border-radius: 5px;
}

.closeDialog {
    width: 80px;
    height: 30px;
    line-height: 30px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    color: #ffffff;
    background-color: #3981e2;
}

.el-table {
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px; /*滚动条宽度*/
        height: 10px; /*滚动条高度*/
    }

    /*定义滚动条轨道 内阴影+圆角*/

    /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
        //   box-shadow: 0px 1px 3px #fff inset; /*滚动条的背景区域的内阴影*/
        border-radius: 10px; /*滚动条的背景区域的圆角*/
        background-color: #fff; /*滚动条的背景颜色*/
    }

    /*定义滑块 内阴影+圆角*/

    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        //   box-shadow: 0px 1px 3px #dddee0 inset; /*滚动条的内阴影*/
        border-radius: 10px; /*滚动条的圆角*/
        background-color: #dddee0; /*滚动条的背景颜色*/
    }
}

.out-container {
    width: 100%;
    /* height: var(--tableHeight);*/
    height: 660px;
    overflow: auto;
}

.inner-container {
    // min-width: 2600px;
    height: var(--tableHeight);
    overflow: hidden;
    scroll-behavior: smooth;
}
//重构新增
.side-search {
    width: 200px;
    background: #FFFFFF;
    border-right: #d3dce6 1px solid;
}

.small-side {
    width: 36px;
    height: 36px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.14);
    border-right: 1px solid #EEE;
}

.mian-content {
    flex: 1;
    background: #F5F7FA;
}

.change-in {
    width: 12px;
    height: 12px;
    background: url("~@/assets/image/intoON.svg") no-repeat;
    background-size: 100% 100%;
}

.head-section {
    padding: 16px;
    background: #FFFFFF;
    overflow: hidden;
}

.btn-end {
    display: flex;
    justify-content: flex-end;
}

.section-main {
    width: 100%;
    //height: calc(100vh - 24px);
    background: #FFFFFF;
    margin-top: 16px;
    padding: 24px 16px 16px 16px;

    .section-title {
        font-size: 16px;
        font-weight: 400;
        color: #2F3133;
        font-family: PingFang SC;
    }
}

.section-main::after {
    /* 清除浮动  （clear: both;元素 作用只能是块元素，行内块元素无效）*/
    content: "";
    height: 0;
    visibility: hidden;
    clear: both;
    display: block;

}

.choose-mian {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    span {
        display: inline-block;
        margin-left: 16px;
    }
}

.alert-box {
    font-size: 14px;
    font-weight: 400;
    color: #585858;
}

.pagin {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

.main-flex {
    display: flex;

}

.left-style {
    padding-left: 43px;
}

.edit-style {
    color: #0D6CE4;
    font-size: 14px;
    cursor: pointer;
}
.more-search {
    display: flex;
    color: #0D6CE4;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    cursor: pointer;
    position: relative;
    left: -15px;
    i{
        line-height: 36px;
    }
}
.head-section{
    /deep/.el-input__inner { //更改input大小
        width: 250px !important;
        height: 36px;
        line-height: 36px;
    }
}
.head-section2 {
    overflow: hidden;
    padding: 0 16px 16px 16px;
    height: 100%;
}
.form-name{
    /deep/.el-input__inner,.el-input{
        width: 220px;
    }
}
</style>
<style lang="less">
@import '@/assets/style/pagestyle.less';
/*选择日期，年份的隐藏 */
.picker-date {
    .el-date-picker__header {
        span:nth-child(3) { /*第三个标签是span的标签，把它隐藏*/
            display: none;
        }
        button:nth-child(1) {
            display: none;
        }
        button:nth-child(5) {
            display: none;
        }
    }
}
</style>

